import {
  mapState,
  mapMutations
} from 'vuex'
import api from '../service/services.js'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'

export default {
  name: 'report',
  data () {
    return {
      screenHeight: window.innerHeight - 220,
      isLoading: false,
      data_user: {},
      password: ''
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapState(['user', 'url']),
    ...mapMutations(['checkLogin', 'logout'])
  },
  methods: {
    getProfile () {
      api.AXprofile(this.url, {
        accesstoken: this.user.token
      },
      result => {
        this.data_user = result.data
      },
      error => {
        alert(JSON.stringify(error))
      }
      )
    },
    changePass () {
      var obj = {
        accesstoken: this.user.token,
        password: this.password
      }
      if (this.password !== '') {
        swal({
          title: 'Are you sure?',
          text: 'Do you want to change your password?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.value) {
            api.AXchangepass(this.url, obj,
              result => {
                swal({
                  type: 'success',
                  title: 'Change Password Complete !!. Please login.',
                  showConfirmButton: false,
                  timer: 1500
                })
                setTimeout(function () {
                  this.logout()
                  location.reload()
                }.bind(this), 1500)
              },
              error => {
                alert(JSON.stringify(error))
              }
            )
          } else {
            location.reload()
          }
        })
      }
    }
  },
  mounted () {
    try {
      this.checkLogin()
    } catch (e) {
      // location.reload()
    }
    this.getProfile()
  }
}



// WEBPACK FOOTER //
// ./src/js/profile.js